import { ILmsProfileModel } from 'models/lmsProfile.model'
import api from '../../..'

const destroyManyProfileSegments = (
  id: number | string,
  q: { id_not_in?: number[]; id_in?: number[]; g: any }
) =>
  api
    .delete(`administration/lms_profiles/${id}/segments/destroy_many`, {
      data: { q },
    })
    .then(({ data }): ILmsProfileModel => data)

export default destroyManyProfileSegments
